import { render, staticRenderFns } from "./StudentGeneralForm.vue?vue&type=template&id=bf34fd2c&scoped=true"
import script from "./StudentGeneralForm.vue?vue&type=script&lang=js"
export * from "./StudentGeneralForm.vue?vue&type=script&lang=js"
import style0 from "./StudentGeneralForm.vue?vue&type=style&index=0&id=bf34fd2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf34fd2c",
  null
  
)

export default component.exports